// useLoading.js
import { useState } from "react";

export function useLoading() {
  const [loadingCount, setLoadingCount] = useState(0);

  const startLoading = () => setLoadingCount((c) => c + 1);
  const stopLoading = () => setLoadingCount((c) => Math.max(0, c - 1));
  const loading = loadingCount > 0;

  const withLoading = async (fn) => {
    startLoading();
    try {
      return await fn();
    } finally {
      stopLoading();
    }
  };

  return { loading, withLoading };
}